export default {
  type: 'N',
  render: (value) => value,
  compare: (a, b) => {
    const _a = a !== undefined ? parseFloat(a) : 0
    const _b = b !== undefined ? parseFloat(b) : 0
    return _a - _b
  }
}
